import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Sidebar from "../../components/layout/Sidebar";
import MetricsOverview from "./MetricsOverview";
import WeeklyReports from "./WeeklyReports";
import TransactionHistory from "./TransactionHistory";
import ProductManagement from "./ProductManagement";
import { useDispatch } from "react-redux";
import { getAllProductsService } from "redux/services/products_sevice";
import { getOrdersService } from "redux/services/orders_service";

const AdminDashboard = () => {

  const dispatch = useDispatch();

  const [featuredProducts, setFeaturedProducts] = useState([]);

  useEffect(()=>{
    dispatch(getAllProductsService({ is_special: 1})).then((response) => {
      if (response?.payload?.status === 200) {
        setFeaturedProducts(response?.payload?.data?.data);
      }
      //setIsLoading(false);
    });
    dispatch(getOrdersService({page:1}))
  },[])
  return (
    <>
      <Helmet>
        <title>
          Admin Dashboard - Sales Analytics & Order Management | DealPort
        </title>
        <meta
          name="description"
          content="Comprehensive admin dashboard for DealPort e-commerce platform. Monitor sales performance, track orders, analyze weekly reports, and manage product inventory with real-time analytics."
        />
        <meta
          property="og:title"
          content="Admin Dashboard - Sales Analytics & Order Management | DealPort"
        />
        <meta
          property="og:description"
          content="Comprehensive admin dashboard for DealPort e-commerce platform. Monitor sales performance, track orders, analyze weekly reports, and manage product inventory with real-time analytics."
        />
      </Helmet>

   

        {/* Dashboard Content */}
        <div className="flex flex-col gap-5 px-4 sm:px-5 lg:px-5 pb-8">
          <MetricsOverview />
          <WeeklyReports />
          <div className="flex flex-col lg:flex-row gap-5">
            <TransactionHistory />
       
          </div>
        </div>
      
    </>
  );
};

export default AdminDashboard;
